/**
 * Template pickers (applicant texting menu, bulk SMS drawer, rule options).
 * Deliberately omits `createdBy` — none of them render it, and every selected
 * relation field is resolved per template on the server.
 */
export const GET_TEXT_TEMPLATES = gql`
  query GET_TEXT_TEMPLATES(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    textTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        textTemplateId
        title
        createdAt
        updatedAt
        content
      }
    }
  }
`

/** Settings list, which is the only place that shows who created a template. */
export const GET_TEXT_TEMPLATES_WITH_CREATOR = gql`
  query GET_TEXT_TEMPLATES_WITH_CREATOR(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    textTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        textTemplateId
        title
        createdAt
        updatedAt
        content
        createdBy {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const RESOLVE_TEXT_TEMPLATE = gql`
  query RESOLVE_TEXT_TEMPLATE($textTemplateId: String!, $applicantId: String!) {
    resolveTextTemplate(
      textTemplateId: $textTemplateId
      applicantId: $applicantId
    ) {
      content
    }
  }
`

export const RESOLVE_TEXT_CONTENT = gql`
  query RESOLVE_TEXT_CONTENT($content: String!, $applicantId: String!) {
    resolveTextContent(content: $content, applicantId: $applicantId) {
      content
    }
  }
`

export const EDIT_TEXT_TEMPLATE = gql`
  mutation EDIT_TEXT_TEMPLATE(
    $textTemplateId: String!
    $input: UpdateTextTemplateInput!
  ) {
    updateTextTemplate(textTemplateId: $textTemplateId, input: $input) {
      content
    }
  }
`

export const CREATE_TEXT_TEMPLATE = gql`
  mutation CREATE_TEXT_TEMPLATE($input: CreateTextTemplateInput!) {
    createTextTemplate(input: $input) {
      content
    }
  }
`

export const DELETE_TEXT_TEMPLATE = gql`
  mutation DELETE_TEXT_TEMPLATE($textTemplateId: String!) {
    deleteTextTemplate(textTemplateId: $textTemplateId) {
      content
    }
  }
`
